<template>
    <section  v-if="hasPermissions(['Census-Worksheet Write', 'Census-Worksheet Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Pariatur dolorem cumque possimus nobis ut iure architecto, assumenda iste cupiditate libero sed debitis magni deleniti enim corporis veniam et aut. Et.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="worksheets.length && hasPermissions(['Census-Worksheet Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button v-if="hasPermissions(['Census-Worksheet Write'])" class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div v-if="hasPermissions(['Census-Worksheet Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="worksheets.length && hasPermissions(['Census-Worksheet Read'])">

            <div class="tab-pane fade" id="cards-listation">
                <div class="row mb-0">
                    <div class="col-sm-6 col-lg-3" v-for="(value, i) in worksheets" :key="i">
                        <div class="row mb-0 no-gutters h-100">
                            <div class="col-12 card cardList hoverable">
                                <div class="card-content h-100">
                                    <div class="card-title">
                                        <div class="row mb-0 no-gutters">
                                            <div class="col-10">
                                                <div v-if="hasPermissions(['Census-Worksheet Write'])">
                                                    <a href="#" @click="modal_update(i)" class="textTitleCard">
                                                        {{ `${i+1}. ${value.description}` }}
                                                    </a>
                                                </div>
                                                <div v-else>
                                                    <a href="#" class="textTitleCard">
                                                        {{ `${i+1}. ${value.description}` }}
                                                    </a>
                                                </div>
                                            </div>
                                            <div v-if="hasPermissions(['Census-Worksheet Write'])" class="col-2 text-right">
                                                <a href="#" @click="modal_deletion(i)">
                                                    <i class="material-icons prefix ">
                                                        <img class="iconCard" src="/assets/img/trash.png" alt="date">
                                                    </i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-12">
                                            <ul class="list">
                                                <li v-html="`Associate: ${value.associate}`" class="list__item"></li>
                                                <li v-html="`Date: ${value.date}`" class="list__item"></li>
                                                <li v-html="`${value.discharge_worksheet_counter}`" class="list__item"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-action right-align">
                                    <a :href="`${child_href}${value.id}`" class="card-action__link">
                                        View more
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="worksheets"
                                :search="search"
                                link="/census-worksheets/"
                                :checkable="true"
                            />
                        </v-card>
                    </div>
                </div>
            </div>

        </div>

         <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />


        <FormModal 
            :title="'New Worksheet'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Worksheet Update'"
            :breadcrumb="breadcrumb"
            :content_header="content_header"
            :rest_api="rest_api"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>
    </section>
     <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>
</template>

<script>
import axios            from    'axios';
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import Resources        from    './resources'
import FormModal        from    './FormModal'
import UpdateModal      from    './UpdateModal'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import DinamicTable     from    '@/components/DinamicTable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {

  name: "Worksheet",

  components: {

    Breadcrumb,
    WaitingModal,
    DeletionMassiveModal,
    FormModal,
    UpdateModal,
    UnauthorizedComponent,
    DinamicTable
  },

  data() {
    return {
        notyf,
        axios,
        user:               this.get_user(),
        child_href:         '/census-worksheets-detail/',
        title_page:         'Worksheets',
        content_header:     this.$store.state.headers,
        rest_api:           `worksheets`,
        notifications:      this.$store.state.form_notyf,
        table_headers:      Resources.table_headers,
        breadcrumb:         Resources.breadcrumb,
        add_btn:            'Add Worksheet',
        single_select:      false,
        table_selection:    [],
        search:             '',
        global_index:       '',
        single_object:      {},
        worksheets:         [],
        array_options:      {},
        select_ids:         [],
    }
  },

  methods: {

        format_boolean(value)
        {
            let boolean_string = ''
            value ? boolean_string = 'Show' : boolean_string = 'Hide'
            return boolean_string
        },

        unshift_object(new_object)
        {
            this.worksheets.unshift(new_object)
        },

        splice_object(splicing_object)
        {
            this.worksheets.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal()
        {
            if(!this.user.has_facility){
                notyf.error('There is not exists a facility yet')
                return false
            }
            window.$('#static').modal('show')
        },

        massive_modal_delete()
        {
            this.select_ids = this.worksheets.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let sendingMassive = await this.massive_delete({ ids: this.select_ids })

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.worksheets.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.worksheets.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.worksheets[index]
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.worksheets = data.worksheets
            this.array_options = {
                associate_id:   data.associates,
                daily_assignment_id: data.daily_assignments,
            }
        },

        trashing(index)
        {
            this.worksheets.splice(index, 1)
        },
  },

    async mounted() {
        if(this.hasPermissions(['Census-Worksheet Write', 'Census-Worksheet Read']))
        {
            await this.api_request()
        }
    },
   computed:
    {
         selected()
        {
            const bool = this.worksheets.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
};
</script>